import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import ApiSecMappingForm from "./ApiSecMappingForm";

const ApiSecCredentialsForm = (props, ref) => {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      rules: [urlRegexValidator],
      required: true,
    },
    {
      name: "apiToken",
      label: "Token",
      type: FieldTypes.PASSWORD,
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={ApiSecMappingForm}
      initialValue={{ apiEndpoint: "https://api.apisecapps.com/v1" }}
    />
  );
};

export default forwardRef(ApiSecCredentialsForm);